/**
 * UnionsRealTimeChat API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ChatTypeEnum } from './chatTypeEnum';


export interface GetChatListDto { 
    /**
     * id чата
     */
    chatId: string;
    /**
     * название чата
     */
    chatName: string;
    /**
     * описание чата
     */
    chatDescription?: string | null;
    chatType: ChatTypeEnum;
    /**
     * Id пользователя собеседника в чате 1 на 1
     */
    directUserId?: string | null;
    /**
     * Признак, что у чата есть аватарка
     */
    isAvatarExists: boolean;
    /**
     * Идентификатор сторонней сущности, например, id-комитета или id-организации
     */
    attachId?: string | null;
    /**
     * Наименование объекта из AttachId
     */
    attachObjectName?: string | null;
    /**
     * Признак - является ли текущий пользователь участником чата
     */
    isChatMember?: boolean;
}
export namespace GetChatListDto {
}


